import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ConfiguratorComponent } from './configurator/configurator.component';
// import { ConfigurationLoader } from './services/configuration.loader';
import { IntroComponent } from './intro/intro.component';

const appRoutes: Routes = [
  { path: 'configurator/:store/:room/:state', component: ConfiguratorComponent },
  { path: 'configurator/:store/:room', component: ConfiguratorComponent },
  { path: 'configurator', component: ConfiguratorComponent },
  { path: ':store', component: IntroComponent },
  { path: '**', component: IntroComponent }
];

export const routing: ModuleWithProviders = RouterModule.forRoot(appRoutes);


// WEBPACK FOOTER //
// ./src/app/app.routing.ts